import React, { useState } from 'react';
import { connect } from 'react-redux';
import styles from './confirmRequestModal.module.scss';
import { Button, WithSpinner, InputWithTextInline } from '../../components';
import DatePicker from 'react-datepicker';
import { actions } from '../../state/actions';
import swal from 'sweetalert';
import { Api } from '../../api/api';
import { config } from '../../api/config';
import { isSumValid2, isInterestRateValid } from '../../utils/auth/validations';
// import { errorhandle } from '../../utils/helpers/helpers';

const ApproveRequestWithAdditionalDocs = ({
  open,
  requestId,
  loading,
  dispatch,
  comment,
  loanDelayTerm,
  loanPurposeId,
  invegaContractNumber2,
  InvegaLoanPaymentTerm2,
  invegaLoanInterestRate2,
  invegaLoanSum2,
}) => {
  const [isLoading, setIsloading] = useState(false);
  const [notValid, setNotValid] = useState(false);
  const [invegaLoanInterestRate, setInvegaLoanInterestRate] = useState(
    invegaLoanInterestRate2
  );

  const [invegaLoanSum, setInvegaLoanSum] = useState(invegaLoanSum2);
  const [invegaContractNumber, setInvegaContractNumber] = useState(
    invegaContractNumber2
  );
  const [fileToUpload, setFileToUpload] = useState(null);
  const [invegaLoanDelayTerm, setInvegaLoanDelayTerm] = useState(loanDelayTerm);
  const [invegaLoanPurposeId, setInvegaLoanPurposeId] = useState(loanPurposeId);
  const [invegaLoanPaymentTerm, setinvegaLoanPaymentTerm] = useState(
    InvegaLoanPaymentTerm2
  );

  const cancel = () => {
    setNotValid(false);
    setInvegaLoanInterestRate(invegaLoanInterestRate2);
    setInvegaLoanDelayTerm(loanDelayTerm);
    setInvegaLoanSum(invegaLoanSum2);
    setInvegaContractNumber(invegaContractNumber2);
    setinvegaLoanPaymentTerm(InvegaLoanPaymentTerm2);
    setFileToUpload(null);
    setInvegaLoanPurposeId(loanPurposeId);

    const open = {
      modalName: 'approveRequestWithAdditionalDocs',
      visible: false,
    };
    dispatch(actions.modals.setModalVisibleFlagAction(open));
  };

  const yes = async () => {
    if (
      (invegaLoanInterestRate &&
        isSumValid2(invegaLoanSum) === null &&
        isInterestRateValid(invegaLoanInterestRate) === null &&
        invegaContractNumber,
      invegaLoanPurposeId)
    ) {
      const dataToSent = {
        comment: comment,
        userCommentRequired: false,
        refusalOfFunding: true,
        invegaLoanInterestRate: invegaLoanInterestRate,
        invegaContractNumber: invegaContractNumber,
        invegaLoanSum: invegaLoanSum,
        invegaLoanDelayTerm: invegaLoanDelayTerm,
        invegaLoanPurposeId: invegaLoanPurposeId,
      };

      setIsloading(true);
      if (true) {
        fetch(
          Api.API_BASE_URL +
            config.API_ENDPOINTS.setApproveWithDocsRequest(requestId),
          {
            method: 'POST',

            headers: {
              Authorization: `Bearer ${window.localStorage.getItem('token')}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ...dataToSent }),
          }
        )
          .then((res) => {
            if (res.ok === true) {
              dispatch(actions.backoffice.getRequestAction(requestId));
              dispatch(actions.backoffice.getGetUploadedFilesAction(requestId));
              dispatch(
                actions.backoffice.saveEditAdditionalComments('get', requestId)
              );
              dispatch(actions.backoffice.getRequestLogAction(requestId));

              cancel();

              swal({
                title:
                  'Paraiška sėkmingai patvirtinta finansavimui (su papildomais dokumentais)',
                icon: 'success',
                buttons: {
                  confirm: {
                    text: 'Gerai',
                    value: true,
                    visible: true,
                    className: 'btn btn-pink',
                    closeModal: true,
                  },
                },
              });
            } else if (res.status === 403) {
              swal({
                title: `Šiam veiksmui atlikti neturite reikiamų teisių. Kreipkitės į sistemos administratorių`,
                icon: 'error',
                buttons: {
                  confirm: {
                    text: 'Gerai',
                    value: true,
                    visible: true,
                    className: 'btn swal-ok-btn',
                    closeModal: true,
                  },
                },
              });
            } else {
              res.json().then((r) => {
                swal({
                  title: `${
                    r.ErrorDescription ? r.ErrorDescription : 'Įvyko klaida'
                  }`,
                  icon: 'error',
                  buttons: {
                    confirm: {
                      text: 'Gerai',
                      value: true,
                      visible: true,
                      className: 'btn swal-ok-btn',
                      closeModal: true,
                    },
                  },
                });
              });
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setIsloading(false);
          });
      } else {
        swal({
          title: `Paraiška negali būti finansuojama nes neatitinka visų finansavimo taisyklių`,
          icon: 'error',
          buttons: {
            confirm: {
              text: 'Gerai',
              value: true,
              visible: true,
              className: 'btn swal-ok-btn',
              closeModal: true,
            },
          },
        });
        setIsloading(false);
        cancel();
      }
    } else {
      setNotValid(true);
    }
  };

  return (
    open && (
      <div className={styles.container}>
        <div
          className={styles.modal}
          id="modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__title"
          aria-describedby="modal__desc"
        >
          <WithSpinner loading={isLoading}>
            <h2>
              Paraiškos tvirtinimas finansavimui (su papildomais dokumentais)
            </h2>
            <div className={styles.inputsContainer}>
              <div
                className={styles.inputsInline}
                style={{ marginLeft: '2.5rem' }}
              >
                <div>
                  <InputWithTextInline
                    type="string"
                    value={invegaContractNumber}
                    onChange={(e) => setInvegaContractNumber(e.target.value)}
                    placeholder={'Sutarties numeris'}
                    disabled={false}
                  />
                  {notValid && !invegaContractNumber && (
                    <p
                      className={styles.error}
                      style={{ textAlign: 'center', width: '100%' }}
                    >
                      Privalote įvesti sutarties numerį
                    </p>
                  )}
                </div>
              </div>

              <div
                className={styles.inputsInline}
                style={{ marginRight: '1rem', marginLeft: '1rem' }}
              >
                <div>
                  <InputWithTextInline
                    type="string"
                    value={invegaLoanSum}
                    onChange={(e) => setInvegaLoanSum(e.target.value)}
                    placeholder={'Paskolos suma'}
                    disabled={false}
                  />
                  {notValid && (
                    <p
                      className={styles.error}
                      style={{ textAlign: 'center', width: '100%' }}
                    >
                      {isSumValid2(invegaLoanSum, 'privalomas laukas', 3)}
                      {/* Privalote įrašyti paskolos sumą */}
                    </p>
                  )}
                </div>
              </div>

              <div
                className={styles.inputsInline}
                style={{ marginRight: '0rem', width: '150px' }}
              >
                <div>
                  <label
                    className="inlineDatepickerInputTitle"
                    style={{ width: '150px', margin: '1.5rem 0 0.6rem 0.5rem' }}
                  >
                    Galutinis paskolos grąžinimo terminas
                  </label>
                  <DatePicker
                    className="inlineDatepickerInput"
                    value={
                      invegaLoanPaymentTerm != null
                        ? new Date(invegaLoanPaymentTerm)
                        : ''
                    }
                    selected={
                      invegaLoanPaymentTerm != null
                        ? new Date(invegaLoanPaymentTerm)
                        : ''
                    }
                    onChange={(e) => setinvegaLoanPaymentTerm(e)}
                    minDate={new Date()}
                    dateFormat="yyyy-MM-dd"
                    disabled={false}
                    style={{ width: '50px' }}
                  />

                  {/*{notValid && !invegaLoanPaymentTerm && (
                    <p
                      className={styles.error}
                      style={{ textAlign: 'center', width: '100%' }}
                    >
                      Įveskite paskolos terminą
                    </p>
                  )}*/}
                </div>
              </div>
              <div
                className={styles.inputsInline}
                style={{ margin: '1.5rem 1.5rem' }}
              >
                <label
                  style={{
                    margin: '8px 0 8px',
                    color: '#597a96',
                    fontSize: '0.8rem',
                    lineHeight: '1.5',
                  }}
                >
                  Atidėjimo terminas (mėn)
                </label>
                <InputWithTextInline
                  name={'LoanDelayTerm'}
                  type={'number'}
                  style={{ marginTop: '-32px' }}
                  onChange={(e) => setInvegaLoanDelayTerm(e.target.value)}
                  value={invegaLoanDelayTerm || ''}
                  //placeholder={requestDataLabelTranslation('LoanDelayTerm')}
                  //disabled={disableCheck('invegaLoanDelayTerm')}
                />
              </div>

              <div
                className={styles.inputsInline}
                style={{ marginRight: '2.5rem' }}
              >
                <div>
                  <InputWithTextInline
                    type="string"
                    value={invegaLoanInterestRate}
                    onChange={(e) => setInvegaLoanInterestRate(e.target.value)}
                    placeholder={'Palūkanų norma, %'}
                    disabled={false}
                  />
                  {notValid && (
                    <p
                      className={styles.error}
                      style={{ textAlign: 'center', width: '100%' }}
                    >
                      {isInterestRateValid(
                        invegaLoanInterestRate,
                        'privalomas laukas',
                        3
                      )}
                      {/* Privalote įrašyti paskolos sumą */}
                    </p>
                  )}
                </div>
              </div>

              <div
                className={styles.inputsInline}
                style={{ marginRight: '2.5rem' }}
              >
                <label
                  style={{
                    margin: '30px 0 8px',
                    color: '#597a96',
                    fontSize: '0.8rem',
                    lineHeight: '1.5',
                  }}
                >
                  Paskolos paskirtis
                </label>
                <select
                  name="LoanPurposeId"
                  onChange={(e) => setInvegaLoanPurposeId(e.target.value)}
                  value={invegaLoanPurposeId}
                >
                  {/* <option value={null}>{null}</option> */}
                  <option value={'1'}>Investicinė</option>
                  <option value={'2'}>Apyvartinė</option>
                </select>
              </div>
            </div>

            <div className={styles.btnContainer}>
              <Button type="standart" onClick={() => yes(requestId)}>
                Išsaugoti
              </Button>
              <Button type="cancel" onClick={() => cancel()}>
                Atšaukti
              </Button>
            </div>
          </WithSpinner>
        </div>
      </div>
    )
  );
};

// const mapStateToProps = (state) => ({
//   loading: state.dashboardState.isOnSync,
// });

export default connect()(ApproveRequestWithAdditionalDocs);
